var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"href":item.path,"link":"","router":"","to":item.path}},[_vm._v(" "+_vm._s(_vm.$t(("route." + (item.meta.title))))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }